import React, { ReactNode } from 'react';
import { OverlayTrigger, Tooltip, OverlayTriggerProps } from 'react-bootstrap';

interface InfoTooltipProps {
  content: string | ReactNode;
  children: ReactNode;
  placement?: OverlayTriggerProps['placement'];
  trigger?: OverlayTriggerProps['trigger'];
  tooltipClassName?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  content,
  children,
  placement = 'top',
  trigger = ['hover', 'focus'],
  tooltipClassName
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      trigger={trigger}
      overlay={
        <Tooltip id="custom-tooltip" className={tooltipClassName}>
          {content}
        </Tooltip>
      }
    >
      <span style={{ cursor: 'pointer' }}>{children}</span>
    </OverlayTrigger>
  );
};

export default InfoTooltip;